// Module-level singleton: persists across route changes within the same browser session.
// File objects can't be stored in localStorage (they serialize to {}), so we keep them here.

let _import = null;  // { dateiname, file, setupKey }
let _file   = null;  // raw File saved before /login navigate (email registration path)

const SS_DATA = 'cvflow_prelogin_cv';
const SS_META = 'cvflow_prelogin_cv_meta';

export const queueCvImport = (dateiname, file, setupKey) => {
  _import = { dateiname, file, setupKey };
  localStorage.setItem('cvflow_cv_import_pending', '1');
};

export const takeCvImport = () => {
  const s = _import;
  _import = null;
  return s;
};

export const hasPendingImport = () =>
  localStorage.getItem('cvflow_cv_import_pending') === '1';

// Email-registration path: save File before navigating away, pick up after return.
// sessionStorage survives window.location.reload() within the same tab, so we persist
// the file there as base64 to handle the email-verification reload.
export const savePreLoginFile = (file) => {
  _file = file;
  const reader = new FileReader();
  reader.onload = () => {
    try {
      sessionStorage.setItem(SS_DATA, reader.result);
      sessionStorage.setItem(SS_META, JSON.stringify({ name: file.name, type: file.type }));
    } catch {}
  };
  reader.readAsDataURL(file);
};

export const takePreLoginFile = () => {
  if (_file) {
    const f = _file;
    _file = null;
    sessionStorage.removeItem(SS_DATA);
    sessionStorage.removeItem(SS_META);
    return f;
  }
  // Post-reload path: reconstruct File from sessionStorage
  try {
    const dataUrl = sessionStorage.getItem(SS_DATA);
    const meta    = JSON.parse(sessionStorage.getItem(SS_META) || 'null');
    if (!dataUrl || !meta) return null;
    sessionStorage.removeItem(SS_DATA);
    sessionStorage.removeItem(SS_META);
    const base64  = dataUrl.split(',')[1];
    const binary  = atob(base64);
    const bytes   = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new File([bytes], meta.name, { type: meta.type });
  } catch {
    return null;
  }
};
